export default __webpack_public_path__ + "static/media/demo-2AR.25008f91.png";